<script setup lang="ts">
import type { Schemas } from '#shopware'

const { t } = useI18n()
const localePath = useLocalePath()

const navigationItems = inject<Ref<Schemas['NavigationRouteResponse'] | null>>('mainNavigation', ref(null))

const mainCategories = computed<Schemas['Category'][]>(() =>
    (navigationItems.value as Schemas['Category'][] | null) ?? []
)

const markenCategory = computed(() =>
    mainCategories.value.find(cat => cat.name === 'Marken')
)

const manufacturers = computed<Schemas['Category'][]>(() =>
    ((markenCategory.value?.children as Schemas['Category'][]) ?? []).filter(cat => cat.active)
)

useSeoMeta({
    title: t('marken.meta.title'),
    description: t('marken.meta.description'),
    robots: 'INDEX, FOLLOW'
})
</script>

<template>
    <div>
        <MarkenSubNavigation />

        <div class="mx-auto max-w-8xl px-4 py-8">
            <h1 class="hidden md:block text-3xl font-bold mb-6">
                {{ $t('marken.pageTitle') }}
            </h1>

            <div class="flex flex-wrap flex-col md:flex-row gap-3 mb-8">
                <NuxtLink
                    :to="localePath('/marken')"
                    class="btn btn-medium btn-primary"
                >
                    {{ $t('marken.filter.all') }}
                </NuxtLink>
                <NuxtLink
                    :to="localePath('/marken/damenschuhe')"
                    class="btn btn-medium btn-secondary"
                >
                    {{ $t('marken.filter.women') }}
                </NuxtLink>
                <NuxtLink
                    :to="localePath('/marken/herrenschuhe')"
                    class="btn btn-medium btn-secondary"
                >
                    {{ $t('marken.filter.men') }}
                </NuxtLink>
                <NuxtLink
                    :to="localePath('/marken/kinderschuhe')"
                    class="btn btn-medium btn-secondary"
                >
                    {{ $t('marken.filter.kids') }}
                </NuxtLink>
            </div>

            <MarkenLexicon :manufacturers="manufacturers" />
        </div>
    </div>
</template>